module.exports = __webpack_public_path__ + "img/icon2.5a5b3154.png";